"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _propTypes = require("prop-types");

var _framerMotion = require("framer-motion");

var _AnimatedEllipsis = _interopRequireDefault(require("../AnimatedEllipsis/AnimatedEllipsis"));

var _icons = require("../../assets/icons");

var _elements = require("../../styles/elements");

var _Drawer = require("./Drawer.styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var DRAWER_PORTAL_ID = 'drawer-root';
var Mask = ( /*#__PURE__*/0, _base["default"])(_framerMotion.motion.div, {
  target: "e19ydwxg0",
  label: "Mask"
})(_Drawer.mask, ";"); // https://letsbuildui.dev/articles/building-a-drawer-component-with-react-portals
// https://codesandbox.io/s/drawer-component-react-hooks-sg357?file=/src/Drawer.jsx:2374-2395

var createPortalRoot = function createPortalRoot() {
  var drawerRoot = document.createElement('div');
  drawerRoot.setAttribute('id', DRAWER_PORTAL_ID);
  return drawerRoot;
};

var UnmanagedDrawer = function UnmanagedDrawer(_ref) {
  var size = _ref.size,
      children = _ref.children,
      className = _ref.className,
      footer = _ref.footer,
      title = _ref.title,
      onClose = _ref.onClose,
      onHide = _ref.onHide,
      isLoading = _ref.isLoading,
      loadingProgress = _ref.loadingProgress,
      isError = _ref.isError,
      isNoResultFound = _ref.isNoResultFound,
      Container = _ref.container,
      contentStyles = _ref.contentStyles,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, ["size", "children", "className", "footer", "title", "onClose", "onHide", "isLoading", "loadingProgress", "isError", "isNoResultFound", "container", "contentStyles"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isLongLoading = _useState2[0],
      setIsLongLoading = _useState2[1];

  var isPreLoadedState = isLoading || isError || isNoResultFound;
  var loadingTimerRef = (0, _react.useRef)();

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      loadingComplete = _useState4[0],
      setLoadingComplete = _useState4[1]; // Clear the timer of tracking whether is long loading


  var bodyRef = (0, _react.useRef)(document.querySelector('body'));
  var portalRootRef = (0, _react.useRef)(document.getElementById(DRAWER_PORTAL_ID) || createPortalRoot());
  (0, _react.useEffect)(function () {
    bodyRef.current.appendChild(portalRootRef.current); // Add overflow-hidden for body when the drawer is open

    bodyRef.current.classList.add('grui', 'overflow-hidden');
  }, []);
  var clearTimer = (0, _react.useCallback)(function () {
    clearTimeout(loadingTimerRef.current);
    loadingTimerRef.current = null;
    setIsLongLoading(false);
  }, []);
  (0, _react.useEffect)(function () {
    if (isLoading) {
      // After 0.75 seconds, show loading text too
      loadingTimerRef.current = setTimeout(function () {
        setIsLongLoading(true);
      }, 750);
    }

    return clearTimer;
  }, [clearTimer, isLoading]);
  (0, _react.useEffect)(function () {
    if (loadingProgress >= 100) {
      clearTimeout(loadingTimerRef.current);
      loadingTimerRef.current = null;
    }
  }, [clearTimer, loadingProgress]);
  (0, _react.useEffect)(function () {
    if (isLoading) {
      setLoadingComplete(false);
    }
  }, [isLoading]);
  var handleClose = (0, _react.useCallback)(function () {
    if (onClose) {
      onClose();
    }
  }, [onClose]); // Allow Escape key to dismiss the drawer

  (0, _react.useEffect)(function () {
    var onKeyPress = function onKeyPress(e) {
      if (e.key === 'Escape') {
        handleClose();
      }
    };

    window.addEventListener('keyup', onKeyPress);
    return function () {
      window.removeEventListener('keyup', onKeyPress);
    };
  }, [handleClose]);
  (0, _react.useEffect)(function () {
    var bodyElement = bodyRef.current;
    return function () {
      if (onHide) onHide(); // Remove overflow-hidden for body when the drawer is removed
      // keep grui class in case it is used for other classes

      bodyElement.classList.remove('overflow-hidden');
    };
  }, [onHide]);
  var handleLoadingProgressEnd = (0, _react.useCallback)(function () {
    setLoadingComplete(!isLoading);
  }, [isLoading]); // Put progresss Bar outside of the loadingState:
  // It can finish the last transition and without delaying showing content

  var progressBar = (0, _jsxRuntime.jsx)("div", {
    css: _Drawer.styles.loadingBar,
    style: {
      transform: "scaleX(".concat(loadingProgress / 100, ")")
    },
    onTransitionEnd: handleLoadingProgressEnd
  });
  var loadingState = (0, _jsxRuntime.jsxs)("div", {
    className: "grui text-center",
    css: [_Drawer.styles.loadingText, isLongLoading && _Drawer.styles.showText, process.env.NODE_ENV === "production" ? "" : ";label:loadingState;"],
    children: [(0, _jsxRuntime.jsx)("p", {
      css: [_elements.paragraph.styles.preflight, _elements.text.styles.textNormal, _elements.text.styles.fontMedium, process.env.NODE_ENV === "production" ? "" : ";label:loadingState;"],
      className: "grui",
      children: "Just a moment"
    }), (0, _jsxRuntime.jsxs)("p", {
      css: _elements.paragraph.styles.preflight,
      className: "grui",
      children: ["Grabbing the data from the backend", (0, _jsxRuntime.jsx)(_AnimatedEllipsis["default"], {})]
    })]
  });
  return /*#__PURE__*/(0, _reactDom.createPortal)((0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(Mask, {
      initial: {
        opacity: 0
      },
      animate: {
        opacity: 1
      },
      transition: {
        duration: 0.15
      },
      exit: {
        opacity: 0,
        delay: 0.15
      },
      onClick: handleClose
    }, "mask"), (0, _jsxRuntime.jsx)(_framerMotion.motion.div, _objectSpread(_objectSpread({
      initial: {
        x: '100%'
      },
      animate: {
        x: '0%'
      },
      transition: {
        duration: 0.15
      },
      exit: {
        x: '100%'
      },
      css: _Drawer.styles.base // eslint-disable-next-line react/jsx-props-no-spreading

    }, restProps), {}, {
      children: (0, _jsxRuntime.jsx)(Container, {
        children: (0, _jsxRuntime.jsxs)("div", {
          css: _Drawer.styles[size],
          className: className,
          children: [(0, _jsxRuntime.jsxs)("div", {
            css: _Drawer.styles.header,
            children: [(0, _jsxRuntime.jsx)("h4", {
              css: _elements.heading.styles.h4,
              className: "grui",
              children: title
            }), (0, _jsxRuntime.jsx)("button", {
              className: "grui",
              css: _elements.button.styles.preflight,
              type: "button",
              onClick: handleClose,
              children: (0, _jsxRuntime.jsx)(_icons.Close, {
                className: "grui block"
              })
            })]
          }), (0, _jsxRuntime.jsxs)("div", {
            css: [_Drawer.styles.main, isPreLoadedState && _Drawer.styles.preLoadedState, contentStyles, process.env.NODE_ENV === "production" ? "" : ";label:UnmanagedDrawer;"],
            children: [!!loadingProgress && !isError && !loadingComplete && progressBar, isError && 'An error has occurred...', isLoading && !isError && loadingState, isNoResultFound && !isError && !isLoading && 'No results found...', !isPreLoadedState && children]
          }), !!footer && footer]
        })
      })
    }), "content")]
  }), portalRootRef.current);
};

UnmanagedDrawer.propTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]).isRequired,

  /**
   * Narrow: 440px; wide: 740px; wideXL: 960px
   */
  size: (0, _propTypes.oneOf)(['narrow', 'wide', 'wideXL']),
  className: _propTypes.string,
  footer: _propTypes.node,
  title: _propTypes.string.isRequired,

  /**
   * Handle close drawer
   */
  onClose: _propTypes.func.isRequired,

  /**
   * Handle when the drawer changes from visible to invisible
   */
  onHide: _propTypes.func,

  /**
   * Whether the content (children) is in a loading state
   * children components will not be rendered if true
   */
  isLoading: _propTypes.bool,

  /**
   * Loading progress: 0 to 100
   */
  loadingProgress: _propTypes.number,

  /**
   * Whether the content (children) has an error
   * children components will not be rendered if true
   */
  isError: _propTypes.bool,

  /**
   * Whether the content (children) has an empty state (for example if a resource could not be found)
   * children components will not be rendered if true
   */
  isNoResultFound: _propTypes.bool,

  /**
   * The drawer body container
   */
  container: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.func]),

  /**
   * Styles for inner content
   */
  contentStyles: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({
    name: _propTypes.string,
    styles: _propTypes.string
  }), _propTypes.func])
};
UnmanagedDrawer.defaultProps = {
  size: 'narrow',
  className: undefined,
  onHide: function onHide() {},
  isLoading: false,
  loadingProgress: undefined,
  isError: false,
  isNoResultFound: false,
  container: 'div',
  contentStyles: undefined,
  footer: undefined
};
var _default = UnmanagedDrawer;
exports["default"] = _default;
//# sourceMappingURL=UnmanagedDrawer.js.map